/** Quantas cores de time o app tem (`team0` a `team3` nos CSS modules); times além do quarto repetem as cores. */
export const TEAM_COLORS = 4;

/** A classe de cor de um time num CSS module (`team0` a `team3`), ou nada quando a pessoa está sem time. */
export function teamClass(styles: Readonly<Record<string, string>>, team: number | null | undefined): string {
  return team === null || team === undefined || team < 0 ? '' : (styles[`team${team % TEAM_COLORS}`] ?? '');
}
